

export const mix_built = {
	watch: {
		$route(to,from){
			this.builtClick()
		},
	},
	data(){
		return {
			built_trimer: null,
			built_loading: '',
		}
	},
	mounted(){
		this.builtClick()
	},
	methods: {
		// 进入页面新建
		builtClick(){
			clearTimeout(this.built_trimer)
			const newbuilt = this.$route.query.newbuilt || ''
			if(newbuilt == '1'){
				this.built_loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.built_trimer = setTimeout(()=>{
					this.createclick()
					this.built_loading.close();
				}, 1200)
			}
		},
	},
}
